(() => {
  'use strict';
  const selector = '.lool-popup-trigger';
  const enhance = () => {
    document.querySelectorAll(selector).forEach((trigger) => {
      if (trigger.tagName !== 'BUTTON' && trigger.tagName !== 'A') {
        trigger.setAttribute('role', 'button');
        if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
      }
    });
  };
  enhance();
  new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('keydown', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!trigger || trigger.tagName === 'BUTTON' || trigger.tagName === 'A') return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    if (!event.repeat && trigger.getAttribute('aria-disabled') !== 'true') trigger.click();
  });
})();

(() => {
  'use strict';
  let saved;
  try {
    saved = JSON.parse(document.getElementById('lucent-lens-options')?.textContent || 'null');
  } catch {
    return;
  }
  if (!Array.isArray(saved?.prescriptionForm?.options) || !Array.isArray(saved?.lensForms)) return;
  const syncLensOptions = () => {
    const collection = window.lensCollections?.ONF2R1?.lensCollection;
    if (!collection) return;
    collection.prescriptionForm = saved.prescriptionForm;
    collection.lensForms = saved.lensForms;
  };
  syncLensOptions();
  document.addEventListener('DOMContentLoaded', syncLensOptions, { once: true });
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('.lool-popup-trigger')) syncLensOptions();
  }, true);
})();

// Some lens-app package cards have click handlers but no keyboard semantics.
(() => {
  'use strict';
  const enhanceCards = () => {
    document.querySelectorAll('.lool-option:not([role])').forEach((card) => {
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('data-lucent-keyboard-card', '');
    });
  };
  enhanceCards();
  new MutationObserver(enhanceCards).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('keydown', (event) => {
    const card = event.target instanceof Element ? event.target.closest('[data-lucent-keyboard-card]') : null;
    if (!card || card.getAttribute('role') !== 'button' || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    if (!event.repeat && card.getAttribute('aria-disabled') !== 'true') card.click();
  });
})();
